import React, { useEffect } from "react";

import Container from "react-bootstrap/Container";

import { Features } from "../../common/SubscriptionFeatures";
import { Col, Row } from "react-bootstrap";
import { useAuth } from "../../auth/hook";
import AccountShopCards from "../components/AccountShopCards";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import AccountHeader from "../components/AccountHeader";
import { useWindowWidth } from "../../api/useWindowWidth";
import AccountAvatar from "../components/AccountAvatar";
import { getAge, getPercentage } from "../utils/functions";
import AccountSubscription from "../components/AccountSubscription";
import { PALETTE } from "../../common/ThemeConstants";

export default function Account() {
  const auth = useAuth();
  const [_, isMobile] = useWindowWidth();
  const user = auth.user;
  const isPremium = auth.userSubscription && auth.userSubscription.id !== -1;
  const cover = user.cover ? user.cover : undefined;

  const age = getAge(user.birthdate);
  const percentage = getPercentage(user);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [auth.userSubscription]);

  return (
    <>
      <AccountHeader />
      <ContainerResponsive>
        <Container className="my-2">
          <Row>
            <Col lg>
              <AccountAvatar
                firstname={user.firstname}
                lastname={user.lastname}
                cover={cover}
                age={age}
                editable={true}
                completionPercentage={percentage}
                size={160}
                sizeInner={150}
              />
              <div className="my-3 m-auto" style={{ maxWidth: "420px" }}>
                <AccountShopCards />
              </div>
            </Col>
            <Col lg>
              <div>
                <AccountSubscription
                  features={Features}
                  color={PALETTE.GRADIENTLIGHT}
                  isPremium={isPremium}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </ContainerResponsive>
    </>
  );
}
